import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["DropdownMenuItem"], _mergeProps(_ctx.$attrs, {
        disabled: $setup.props.disabled,
        class: $setup.cn('relative flex cursor-pointer select-none items-center rounded p-1.5 text-sm outline-none whitespace-nowrap', 'hover:bg-accent hover:text-accent-foreground', 'data-highlighted:bg-accent data-highlighted:text-accent-foreground', 'data-disabled:pointer-events-none data-disabled:opacity-50', $setup.props.class)
    }), {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["disabled", "class"]));
}
